<template>
    <div id="selecao-de-projeto-de-subsidio" class="column">
        <div class="container container_com-fundo container_com-margem">
            <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
            <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
            <div class="formulario">
                <h2 class="titulo titulo_grande u-margem-inferior-media u-margem-esquerda-pequena">
                Selecione o projeto para efetuar o cadastro
                </h2>
                <div class="grade__linha grade__linha_alinhar-vertical-a-base">
                  <div class="grade__coluna grade__coluna_3">
                      <label for="projeto">Projeto</label>
                      <select id="projeto" name="projeto" v-model="projeto" @change="redirecionar">
                      <option v-for="projeto in projetos" :value="projeto">
                          {{ projeto.Nome }}
                      </option>
                      </select>
                  </div>
                </div>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';

export default {
    name: 'selecao-de-projeto-de-subsidio',
    components: { Loading, Alerta },

    data() {
      return {
        loading: false,
        textoDoAlerta: null,
        tipoDoAlerta: null,
        projetos: this.projetos || [],
        projeto: {},
        tipoDeAlerta: null,
        mensagemDeAlerta: null,
        loading: {
          visivel: false,
        },
      };
    },
    created() {
      this.$localStorage.limparRegistros();
      this.obterProjetos();
    },
    directives: { mask: AwesomeMask },
    methods: {
      obterProjetos() {
        this.exibirCarregamento();
        this.$api.get('/Projeto/ObterVigentes').then((response) => {
          this.esconderCarregamento();
          let projetoPadrao = this.criarProjetoPadrao();
          this.projeto = projetoPadrao;
          this.projetos = [projetoPadrao];
          this.projetos = this.projetos.concat(response.data);

          if (!this.$usuario.possuiPermissao("SolicitacaoDeSubsidioParaMcmvCidades")) {
            this.projetos = this.projetos.filter(projeto => projeto.Tipo !== "McmvCidades");
          }

        }).catch((error) => {
          this.tratarErro(error);
        });
      },
      redirecionar(){
        this.$localStorage.atribuir("projeto", this.projeto );
        if (this.projeto.Tipo === "Projeto"){
          this.redirecionarParaConsultaDeCpf(this.projeto.Id);
        };
        if (this.projeto.Tipo === "McmvCidades"){
          this.redirecionarParaConsultaDeCpfParaMcmvCidades(this.projeto.Id)
        }
      },
      redirecionarParaConsultaDeCpf(projetoId) {
        this.$router.push({ name: 'ConsultaPorCpf', params: { projetoId: projetoId }});
      },
      redirecionarParaConsultaDeCpfParaMcmvCidades(projetoId) {
        this.$router.push({ name: 'ConsultaPorCpfParaMcmvCidades', params: { projetoId: projetoId }});
      },
      tratarErro(error) {
        this.esconderCarregamento();
        let mensagensDeErro = error.response.data.Message;
        this.exibirAlerta(mensagensDeErro);
      },
      exibirCarregamento(mensagem) {
        this.loading.visivel = true;
        this.loading.mensagem = mensagem;
      },
      ocultarAlerta() {
        this.textoDoAlerta = null;
        this.mensagemDeAlerta = null;
      },
      exibirCarregamento(mensagem) {
        this.loading.visivel = true;
        this.loading.mensagem = mensagem;
      },
      esconderCarregamento() {
        this.loading.visivel = false;
        this.loading.mensagem = null;
      },
      retornarParaSelecaoDeProjetos() {
        this.deveExibirFormularioParaRendaFamiliarComprovada = false;
        this.mensagemDeAlerta = null;
        this.cpf = null;
        this.limparProjetoSelecionado();
        this.definirProjetoPadrao();
      },
      definirProjetoPadrao() {
        let projetoPadrao = this.criarProjetoPadrao();
        this.projeto = projetoPadrao;
      },
      criarProjetoPadrao() {
        return { Id: null, Nome: 'Selecione o projeto', DeveComprovarRendaFamiliar: false }
      },
      limparProjetoSelecionado() {
        this.projeto = {}
      },
      exibirAlerta(mensagem) {
        this.tipoDeAlerta = 'erro';
        this.mensagemDeAlerta = mensagem || 'Ocorreu um erro interno. Tente novamente ou contate o suporte';
      },
    },
  };
  </script>



// WEBPACK FOOTER //
// SelecaoDeProjetoDeSubsidio.vue?63518e86